/* eslint-disable max-len */
import React, { useContext, useRef, useEffect } from 'react';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import AnimatedModel from '../../../../components/Animation/AnimatedModel';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux'
import GlobalContext from '../../../../components/Context/GloablContext';
import { CognitoData } from '../../../../CommonMethods/CognitoData';
 
const VoucherSelectionPopup = ({
    handleClose, 
    voucherTotalCount,
}) => {
    const {isSideNavBar} = useContext(GlobalContext)
    const outsideClickRef = useRef();
    const navigate = useNavigate();
    useOnClickOutside(outsideClickRef, () => {
        handleClose();
    });
    const {rolesGlobal} = useContext(GlobalContext);
    const GlobalChange=useSelector(state=>state.GlobalData)
    const [voucherType, setVoucherTypes] = React.useState([]);

    useEffect(() => {
        const fetchUser = async () => {
            const user = await CognitoData();
            let roles = rolesGlobal || user.idToken.payload["cognito:groups"];
            const voucherType1 = [
                { key: "Contra", label: "Contra" },
                { key: "Payment", label: "Payment" },
                { key: "Receipt", label: "Receipt" },
            ];

            if (user.idToken.payload['custom:user_type'] === "institution-admin" || roles.includes('collect-fee:rte') || roles.includes('collect-fee:scholarship')) {
                // Example: Only allow 'Receipt' and 'RTE-Scholarship' for non-admins with specific roles
                voucherType1.push(
                    { key: "RTE-Scholarship", label: "RTE/Scholarship" }
                );
            }
            voucherType1.push(
                { key: "Journal", label: "Journal" }
            );
            
            setVoucherTypes(voucherType1);
        };
        fetchUser();
    }, [GlobalChange])


    const handleTypeSelection = (type) => {
        navigate(`/accounting/voucher-entry/voucher-type-${type.toLowerCase()}`)
    }
    // removed from first div (bg-black bg-opacity-50)
    return (
        <AnimatedModel 
            Children={  
                <div className={`vchr_type_drp_dwn shadow-s1${voucherType.length === 4 ? ' top1' : ''}`} ref={outsideClickRef}>
                    <h1 className='text-[#106EB4] flex justify-center items-center font-semibold text-f7 border-b border-[#D0D5DD]'>Select Voucher Type</h1>
                    <div className='px-3'>
                        {voucherType.map((item) => (
                            <p
                                className='pt-2 text-f7 font-normal text-[#031624] cursor-pointer hover:text-[#106EB4]'
                                key={item.key}
                                id={item.key}
                                onClick={() => handleTypeSelection(item.key)}
                            >
                                {item.label}
                            </p>
                        ))}
                    </div>
                </div>
            }
        />
    );
}

export default VoucherSelectionPopup;
